// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userCreators from '../actions/users/userCreators';
import { getLoggedInUser } from '../actions/authentication/authCreators';
import { redirectTo } from '../actions/generalCreators';
import { Grid, Row, Col, Alert } from 'react-bootstrap';
import Banner from '../components/Banner';
import Header from '../components/Header';
import UserRegistrationForm from './users/UserRegistrationForm';
import UserPhoneVerificationForm from './users/UserPhoneVerificationForm';
import { formValueSelector } from 'redux-form';
import { Helmet } from 'react-helmet';
import type { Dispatch } from 'redux';
import type { User } from '../types';

type Props = {
  location: Object,
  email: string,
  phone: string,
  authentication: ?Object,
  router: any,
  getLoggedInUser: (t: ?string) => void,
  registerUser: Function,
  registerInvitedUser: (u: User, t: ?string) => Promise<void>,
  sendVerificationSMS: Function,
  checkVerificationCode: Function,
  sendVerificationEmail: Function
};

type State = {
  token: ?string,
  isSaving: boolean,
  showVerification: boolean,
  isSending: boolean,
  isVerifying: boolean,
  messageSent: boolean,
  user?: any,
  errorMsg?: string,
  successMsg?: string
};

class Register extends React.Component<Props, State> {
  timeoutId: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      token: undefined,
      isSaving: false,
      errorMsg: undefined,
      showVerification: false,
      isSending: false,
      isVerifying: false,
      messageSent: false
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    // Get current User from query string
    // (might need to change this to a token rather than a userId)
    const token = this.props.location.query.token;
    if (token) {
      this.setState({ token });
      this.props.getLoggedInUser(token);
    }
  }

  handleRegisterSubmit = user => {
    this.setState({ user });
    const token = this.state.token;
    const { registerUser, registerInvitedUser } = this.props;
    const registerFunction = !!token ? registerInvitedUser : registerUser;

    // register new or invited user
    this.registerUser(user, registerFunction, this.state.token);
  };

  registerUser = (user, registerFunction, token = undefined) => {
    this.setState({ isSaving: true, errorMsg: undefined });
    registerFunction(user, token).then(
      response => {
        console.log('Successfully added user');
        this.setState({ isSaving: false, showVerification: true });

        // Send sms verification
        this.sendSMS(user.phone);
      },
      error => {
        let errorMsg;
        if (error.data.message === `Password doesn't meet the requirements`) {
          errorMsg = `Password must be minimum of 8 characters. Must contain at least one number, one uppercase, and one lowercase letter.`;
        } else {
          errorMsg = error.data.message;
        }
        this.setState({
          isSaving: false,
          showVerification: false,
          errorMsg
        });
      }
    );
  };

  sendSMS = phoneNumber => {
    this.setState({ errorMsg: undefined, messageSent: false });
    this.props.sendVerificationSMS(phoneNumber).then(
      success => {
        this.setState({ messageSent: true });
      },
      error => {
        this.setState({ errorMsg: error.data.message });
      }
    );
  };

  verifyCode = values => {
    this.setState({ isVerifying: true, errorMsg: undefined });
    this.props.checkVerificationCode(values.code).then(
      user => {
        this.setState({ isVerifying: false });
        if (user.isMobileVerified) {
          if (user.isEmailVerified) {
            if (this.state.token) {
              return this.props.router.push(`/welcome`);
            }
            // redirect to default page
            redirectTo(user.defaultPage || '/');
          } else {
            // send email verification
            this.props.sendVerificationEmail(this.props.email);
            // redirect to the My Account page for email verification
            redirectTo('/account');
          }
        } else {
          this.setState({
            errorMsg:
              'That verification code is not valid. Please check the code and try again.',
            messageSent: undefined
          });
        }
      },
      error => {
        this.setState(error.data.message);
      }
    );
  };

  render() {
    const { authentication } = this.props;
    const { messageSent, showVerification } = this.state;
    return (
      <div>
        <Helmet>
          <title>Register | Campaign Targeter</title>
        </Helmet>
        <Header
          currentOrganisation={{}}
          authentication={{}}
          routeName={'Campaign Targeter'}
          params={{}}
        />

        <Banner title="Register" image="mailbox" />
        <Grid>
          <Row>
            <Col sm={8} smOffset={2} md={8} mdOffset={3} lg={6} lgOffset={3}>
              <UserRegistrationForm
                onSubmit={this.handleRegisterSubmit}
                initialValues={authentication ? authentication.user : {}}
                errorMsg={this.state.errorMsg}
                successMsg={this.state.successMsg}
                isSaving={this.state.isSaving}
                showSubmit={!this.state.showVerification}
                disableFilled={!!this.state.token}
                enableReinitialize
              />

              {messageSent && (
                <div>
                  <Alert bsStyle="info">
                    <p className="help-block">
                      An SMS with a verification code has been sent the phone
                      number specified above.
                    </p>
                  </Alert>
                  <br />
                </div>
              )}

              {showVerification && (
                <UserPhoneVerificationForm
                  onSubmit={this.verifyCode}
                  isVerifying={this.state.isVerifying}
                  resendSMS={this.sendSMS}
                  initialValues={{}}
                  phone={this.props.phone}
                  enableReinitialize
                />
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    phone: formValueSelector('userRegistrationForm')(state, 'phone'),
    email: formValueSelector('userRegistrationForm')(state, 'email')
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...userCreators,
      getLoggedInUser
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);



// WEBPACK FOOTER //
// ./src/containers/Register.js